export const environment = {
	production: false,
	url: 'https://atlas.itca.edu.ec',
	// url: 'https://atlasdevelopment.itca.edu.ec',
	// url: 'http://localhost:3000',
	// url: 'http://192.168.1.3:3000', // poner aquí la ip del equipo que va exponer el proyecto
	localUrl: 'http://atlasdevelopment.itca.edu.ec',
	urlMoodle: 'https://virtualcap.tecnologicoitca.edu.ec/webservice/rest/server.php?moodlewsrestformat=json&wstoken=3dbf332049c3e13f4b0265e67b68e3a0',
	googleAPIKEY: 'AIzaSyCIcRNDK_-6DGJ-tLRcHEnKw2Pk1iehIp8',
	pullZone: 'https://atlasitca.b-cdn.net',
	loginBackground: './assets/images/ITCA-Ibarra.jpg',
	signupBackground: './assets/images/ATLAS_N_Ibarra.jpg',
};
